import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal
} from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { MatRadioGroup } from "@angular/material/radio";
import { MatDivider } from "@angular/material/divider";
import {
  PackageResponse,
  PackageTypeEnum,
  WorkshopSystemEnum
} from "src/domain/client";
import { FormService } from "src/app/services/form.service";
import { IconService } from "src/app/services/icon.service";
import { SectionTogglerComponent } from "../../layout/section-toggler/section-toggler.component";
import { PackageContainerComponent } from "../../layout/package-container/package-container.component";
import { FaultReportComponent } from "../../layout/fault-report/fault-report.component";
import { PackagesFilterPipe } from "src/app/pipes/packages-filter.pipe";

@Component({
  selector: "app-specs-troubleshooting-section",
  templateUrl: "./specs-troubleshooting-section.component.html",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SectionTogglerComponent,
    ReactiveFormsModule,
    MatRadioGroup,
    PackageContainerComponent,
    MatDivider,
    FaultReportComponent,
    TranslateModule,
    PackagesFilterPipe
  ]
})
export class SpecsTroubleshootingSectionComponent {
  packages = input.required<PackageResponse[]>();

  toggle = signal(false);
  WorkshopSystemEnum = WorkshopSystemEnum;
  PackageTypeEnum = PackageTypeEnum;

  constructor(
    public formService: FormService,
    public iconService: IconService
  ) {}

  get form(): FormGroup {
    return this.formService.chooseSpecificationsForm.controls
      .troubleshootingForm as FormGroup;
  }

  getPackageFormGroup(id: string): FormGroup {
    return this.form.get(id) as FormGroup;
  }
}
